export function isRenderableLoopItem(item) {
  return typeof item === 'object' && item !== null && !Array.isArray(item) || typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean';
}